export class Group {
    constructor(
        public id: string = null,
        public itemName: string = '',
        public users: Array<number> = []
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/Group.ts